import integrationsClient, { ApiDefinition } from '@/tsClient/servers/integrationsService';

type THIS_API = ApiDefinition['/submission-attempts/{id}/messages']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getCaseSubmissionMessages = async ({ id, page, perPage }: Input): Promise<Output> => {
  const response = await integrationsClient.get(`/submission-attempts/${id}/messages`, {
    params: { page, perPage },
  });
  return response.data;
};

export default getCaseSubmissionMessages;
